/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_WithdrawInputs */

const th_event_withdraw = /** @type {(inputs: Event_WithdrawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ถอนตัว`)
};

const en_event_withdraw = /** @type {(inputs: Event_WithdrawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Withdraw`)
};

const ja_event_withdraw = /** @type {(inputs: Event_WithdrawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`取り消す`)
};

const zh_event_withdraw = /** @type {(inputs: Event_WithdrawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`退出`)
};

const es_event_withdraw = /** @type {(inputs: Event_WithdrawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retirar`)
};

const pt_event_withdraw = /** @type {(inputs: Event_WithdrawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retirar`)
};

const id_event_withdraw = /** @type {(inputs: Event_WithdrawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarik diri`)
};

const fr_event_withdraw = /** @type {(inputs: Event_WithdrawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retirer`)
};

const tl_event_withdraw = /** @type {(inputs: Event_WithdrawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Umatras`)
};

const vi_event_withdraw = /** @type {(inputs: Event_WithdrawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rút lui`)
};

const ko_event_withdraw = /** @type {(inputs: Event_WithdrawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`철회`)
};

const de_event_withdraw = /** @type {(inputs: Event_WithdrawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zurückziehen`)
};

const ru_event_withdraw = /** @type {(inputs: Event_WithdrawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сняться`)
};

const tr_event_withdraw = /** @type {(inputs: Event_WithdrawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Çekil`)
};

const it_event_withdraw = /** @type {(inputs: Event_WithdrawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ritirati`)
};

const pl_event_withdraw = /** @type {(inputs: Event_WithdrawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wycofaj`)
};

const uk_event_withdraw = /** @type {(inputs: Event_WithdrawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Знятися`)
};

const hi_event_withdraw = /** @type {(inputs: Event_WithdrawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नाम वापस लें`)
};

const ar_event_withdraw = /** @type {(inputs: Event_WithdrawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الانسحاب`)
};

const ms_event_withdraw = /** @type {(inputs: Event_WithdrawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarik diri`)
};

const bn_event_withdraw = /** @type {(inputs: Event_WithdrawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`প্রত্যাহার`)
};

const zh_tw2_event_withdraw = /** @type {(inputs: Event_WithdrawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`退出`)
};

const zh_hk2_event_withdraw = /** @type {(inputs: Event_WithdrawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`退出`)
};

const ur_event_withdraw = /** @type {(inputs: Event_WithdrawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`دستبردار ہوں`)
};

const fa_event_withdraw = /** @type {(inputs: Event_WithdrawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`انصراف`)
};

const sw_event_withdraw = /** @type {(inputs: Event_WithdrawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jitoe`)
};

const nl_event_withdraw = /** @type {(inputs: Event_WithdrawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terugtrekken`)
};

/**
* | output |
* | --- |
* | "Withdraw" |
*
* @param {Event_WithdrawInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const event_withdraw = /** @type {((inputs?: Event_WithdrawInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_WithdrawInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_event_withdraw(inputs)
	if (locale === "ja") return ja_event_withdraw(inputs)
	if (locale === "zh") return zh_event_withdraw(inputs)
	if (locale === "es") return es_event_withdraw(inputs)
	if (locale === "pt") return pt_event_withdraw(inputs)
	if (locale === "id") return id_event_withdraw(inputs)
	if (locale === "fr") return fr_event_withdraw(inputs)
	if (locale === "tl") return tl_event_withdraw(inputs)
	if (locale === "vi") return vi_event_withdraw(inputs)
	if (locale === "ko") return ko_event_withdraw(inputs)
	if (locale === "de") return de_event_withdraw(inputs)
	if (locale === "ru") return ru_event_withdraw(inputs)
	if (locale === "tr") return tr_event_withdraw(inputs)
	if (locale === "it") return it_event_withdraw(inputs)
	if (locale === "pl") return pl_event_withdraw(inputs)
	if (locale === "uk") return uk_event_withdraw(inputs)
	if (locale === "hi") return hi_event_withdraw(inputs)
	if (locale === "ar") return ar_event_withdraw(inputs)
	if (locale === "ms") return ms_event_withdraw(inputs)
	if (locale === "bn") return bn_event_withdraw(inputs)
	if (locale === "zh-TW") return zh_tw2_event_withdraw(inputs)
	if (locale === "zh-HK") return zh_hk2_event_withdraw(inputs)
	if (locale === "ur") return ur_event_withdraw(inputs)
	if (locale === "fa") return fa_event_withdraw(inputs)
	if (locale === "sw") return sw_event_withdraw(inputs)
	if (locale === "nl") return nl_event_withdraw(inputs)
	return en_event_withdraw(inputs)
});